<template lang="pug">
section.singleDetails#details
  .singleDetails-left
    h2.singleDetails-title {{ listing && listing.title }}
    .singleDetails-singleParams.singleParams
      .singleParams-section._price(v-if='listing && listing.priceValue')
        .singleParams-key {{ listing.priceValue | toCurrency }}
        .singleParams-value._price
          span PRICE
          SvgComponent(name='tip', tabindex='0')
          .singleParams-tip Prices are subject to tax and service charges
      .singleParams-props
        .singleParams-section(v-if='listing && listing.beds')
          .singleParams-key 
            SvgComponent(name='bed')
            span {{ listing && listing.beds }} bd
          .singleParams-value BEDS
        .singleParams-section(v-if='listing && listing.baths')
          .singleParams-key
            SvgComponent(name='bath')
            span {{ listing && listing.baths }}{{halfBathRender()}} ba
          .singleParams-value TOTAL BATHS
        //- .singleParams-section(v-if='listing && listing.for == "for_rent"')
        //-   .singleParams-key {{ listing && listing.maxGroup }}
        //-   .singleParams-value MAX GROUP
        .singleParams-section(v-if='listing && listing.sqft')
          .singleParams-key 
            SvgComponent(name='sqft')
            span {{ listing && listing.sqft }} sqft
          .singleParams-value SQFT
        .singleParams-section(v-if='listing && listing.acres')
          .singleParams-key 
            SvgComponent(name='sqft')
            span {{ listing && listing.acres }} ac
          .singleParams-value ACRES  
      .singleParams-location {{ listing && listing.address }}
  p.singleDetails-text {{ listing && listing.Content.details }}
</template>

<script>
  import SvgComponent from '@/components/SvgComponent';

  

  export default {
    components: {
      SvgComponent,
    },
    props: ['listing'],
    methods:{
      halfBathRender() {
        
        if (!this.listing.halfbaths) {
          return '';
        }
        if (this.listing.halfbaths == 1) {
          return '.5';
        }
        if (this.listing.halfbaths > 1) {
          return ` + ${this.listing.halfbaths}half`;
        }
      },
    }
  };
</script>

<style lang="scss">
  .singleDetails {
    padding: 150px 0;
    display: flex;
    /* flex-direction: column; */
    /* @include gap(50px, col); */
    gap: 30px;
    position: relative;
    background: #FFFAF3;



    &-left {
      display: flex;
      flex-direction: column;
      min-width: 495px;

      @include phone {
        min-width: 100%;
      }
      
    }

    &-title {
      font-size: 72px;
      line-height: 77px;
      font-family: 'Abhaya Libre';
      @include middle {
        font-size: 36px;
        line-height: 43px;
      }
      @include tablet {
        font-size: 42px;
        line-height: 43px;
      }
     
    }
    &-text {
      font-size: 16px;
      line-height: 32px;
      /* text-wrap: pretty; */

      @include phone {
        font-size: 16px;
        line-height: 28px;
      }
    }
    @include middle {
      padding: 100px 0;
    }
    @include tablet {
      align-items: center;
      padding: 64px 0 56px;
    }

    @include phone {
      flex-direction: column;
      padding: 40px 0;
    }
  }
  .singleParams {
    
     &-props {
      display: flex;
      gap: 20px;

      @include phone {
        gap: 12px;
      }
    }
   

   &-location {
    @include phone {
      margin-top: 12px;
      font-size: 16px;
    }
    
   }
    
    
    &-section {
      display: flex;
      flex-direction: column;
      align-items: left;
      padding: 12px 0;
      @include gap(15px, col);
      @include middle {
        min-width: auto;
        /* width: 100%; */
        @include gap(10px, col);
        padding: 24px 0;
      }

      @include phone {
        padding: 12px 0 0 0;

        &:nth-child(4) {
          display: none;
        }
      }

      &._price {
        min-width: 220px;
        position: relative;
        .svg-tip:hover + .singleParams-tip {
          opacity: 1;
        }

        .singleParams-key {
          font-size: 26px;
          font-weight: bold;

          @include tablet {
            font-size: 24px;
          }
        }

        @include middle {
          min-width: auto;
        }
        @include tablet {
          min-width: 150px;
          position: static;
        }
      }

    }
    &-key {
      font-weight: 600;
      font-size: 20px;
      line-height: 24px;
      display: flex;
      align-items: center;
      gap: 8px;

      

      @include tablet {
        font-size: 24px;
      }
      @include middle {
        font-size: 16px;
      }

      @include phone {
        font-size: 16px;
        gap: 4px;
      }
    }
    &-value {
      font-weight: 300;
      font-size: 14px;
      line-height: 17px;
      display: none;
      @include middle {
        font-size: 10px;
      }
      &._price {
        /* display: flex; */
        display: none;
        @include gap(10px, row);
        align-items: center;
      }
      @include tablet {
        font-size: 16px;
      }


    }
    &-tip {
      position: absolute;
      white-space: nowrap;
      // bottom: -20px;
      transform: translateY(100%);
      left: -10px;
      padding: 20px;
      font-size: 16px;
      line-height: 19px;
      background: white;
      filter: drop-shadow(0px 4px 20px rgba(0, 0, 0, 0.15));
      opacity: 0;
      transition: opacity 0.2s;
      &::after {
        content: '';
        position: absolute;
        left: 123px;
        border: 10px solid transparent;
        border-bottom: 10px solid white;
        top: -19px;
        @include tablet {
          left: 54%;
        }
      }
      @include tablet {
        bottom: auto;
        left: 0;
        width: 100%;
        text-align: center;
        margin: 0 !important;
        // white-space: normal;
      }
    }
  }
</style>
